import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Check, X, AlertTriangle, Info } from 'lucide-react';
import { hideToast } from '../redux/store';

const Toast = ({ message, type = 'info', duration = 3000 }) => {
  const dispatch = useDispatch();
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      dispatch(hideToast());
    }, 300); // Wait for exit animation
  };

  const typeStyles = {
    success: 'bg-white dark:bg-slate-900 border-emerald-500/20 text-emerald-800 dark:text-emerald-400 shadow-emerald-100 dark:shadow-none',
    error: 'bg-white dark:bg-slate-900 border-red-500/20 text-red-800 dark:text-red-400 shadow-red-100 dark:shadow-none',
    warning: 'bg-white dark:bg-slate-900 border-amber-500/20 text-amber-800 dark:text-amber-400 shadow-amber-100 dark:shadow-none',
    info: 'bg-white dark:bg-slate-900 border-indigo-500/20 text-indigo-800 dark:text-indigo-400 shadow-indigo-100 dark:shadow-none'
  };

  const icons = {
    success: (
      <div className="w-9 h-9 rounded-xl bg-emerald-500 flex items-center justify-center text-white shadow-lg shadow-emerald-100 dark:shadow-none">
        <Check size={20} strokeWidth={3} />
      </div>
    ),
    error: (
      <div className="w-9 h-9 rounded-xl bg-red-500 flex items-center justify-center text-white shadow-lg shadow-red-100 dark:shadow-none">
        <X size={20} strokeWidth={3} />
      </div>
    ),
    warning: (
      <div className="w-9 h-9 rounded-xl bg-amber-500 flex items-center justify-center text-white shadow-lg shadow-amber-100 dark:shadow-none">
        <AlertTriangle size={20} strokeWidth={2} />
      </div>
    ),
    info: (
      <div className="w-9 h-9 rounded-xl bg-indigo-500 flex items-center justify-center text-white shadow-lg shadow-indigo-100 dark:shadow-none">
        <Info size={20} strokeWidth={3} />
      </div>
    )
  };

  return (
    <div role="alert" aria-live="assertive" className={`
            fixed bottom-8 right-8 z-[200] max-w-[340px] w-full transition-all duration-300 transform
            ${isExiting ? 'translate-x-[120%] opacity-0 scale-95' : 'translate-x-0 opacity-100 slide-in-from-right-full'}
        `}>
      <div className={`
                flex items-center gap-4 p-4 rounded-2xl border-2 shadow-2xl transition-colors duration-300
                ${typeStyles[type] || typeStyles.info}
            `}>
        {icons[type] || icons.info}
        <div className="flex-1">
          <p className="text-sm font-bold tracking-tight leading-tight">{message}</p>
          <p className="text-[10px] font-bold opacity-50 uppercase tracking-widest mt-0.5">Notification</p>
        </div>
        <button
          onClick={handleClose}
          className="p-1.5 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors group"
        >
          <X size={20} strokeWidth={2.5} className="opacity-30 group-hover:opacity-100 transition-opacity" />
        </button>
      </div>
    </div>
  );
};

export default Toast;
